
const Header = () => import('@/components/technician/Header/index');
const Footer = () => import('@/components/technician/Footer/index');
// 首页
const techHome = () => import('@/views/technician/techHome.vue');
// 当前任务
const techTask = () => import('@/views/technician/techTask.vue');
// 历史任务
const techHistory = () => import('@/views/technician/techHistory.vue');
// 我的
const techMy = () => import('@/views/technician/techMy.vue');
// 网点信息
const techSiteId = () => import('@/views/technician/techSiteId.vue');
// 巡检列表
const techListInspection = () => import('@/views/technician/techListInspection.vue');
//耗材出库
const consume = () => import('@/views/technician/consume.vue');
// 阳光公示
const sunIndex = ()=>import('@/views/sun/index.vue');
// 预览文章（有pdf预览功能）
const viewPdf = ()=>import('@/views/sun/viewPdf.vue');
// 单独的我的页面
const personal = () => import('@/views/personal/index.vue');
// techSiteIdInfo
const techSiteIdInfo = () => import('@/views/technician/techSiteIdInfo.vue');
const clockIn = () => import('@/views/technician/clockIn.vue');
const saleStatistic = () => import('@/views/technician/saleStatistic.vue');
const saleOutletSite = () => import('@/views/technician/saleOutletSite.vue');
const saleSiteInfo = () => import('@/views/technician/saleSiteInfo.vue');
const setting = () => import('@/views/technician/setting.vue');
// //装机
// const techAddInfo = () => import('@/views/technician/nouse/techAddInfo.vue');
// //移机
// const techMoveInfo = () => import('@/views/technician/nouse/techMoveInfo.vue');
// //撤机
// const techRemoveInfo = () => import('@/views/technician/nouse/techRemoveInfo.vue');
// //巡检
// const techInspection = () => import('@/views/technician/nouse/techInspection.vue');
// // 代销者变更
// const techUserUpdate = () => import('@/views/technician/nouse/techUserUpdate.vue');
// const map = ()=>import('@/components/technician/mapNav/demo.vue');
export default [
    {
        path: '/techHome',
        name: 'techHome',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '首页',
        },
        components: {
            default: techHome,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/techTask',
        name: 'techTask',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '当前任务',
        },
        components: {
            default: techTask,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/techHistory',
        name: 'techHistory',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '历史任务',
        },
        components: {
            default: techHistory,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/techMy',
        name: 'techMy',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '我的',
        },
        components: {
            default: techMy,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/techSiteId',
        name: 'techSiteId',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '网点信息',
        },
        components: {
            default: techSiteId,
            header:Header,
            // footer:Footer,
        }
    },
    {
        path: '/techListInspection',
        name: 'techListInspection',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '彩票销售场所规范化巡检',
        },
        components: {
            default: techListInspection,
            header:Header,
            // footer:Footer,
        }
    },
    {
        path: '/sunIndex',
        name: 'sunIndex',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '阳光公示',
        },
        components: {
            default: sunIndex,
            // header:Header,
            // footer:Footer,
        }
    },{

        path: '/viewPdf',
        name: 'viewPdf',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '文章',
        },
        components: {
            default: viewPdf,
            // header:Header,
            // footer:Footer,
        }
    },
    {
        path: '/consume',
        name: 'consume',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '热敏纸申请记录',
        },
        components: {
            default: consume,
            header:Header,
            // footer:Footer,
        }
    },{
        path: '/personal',
        name: 'personal',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '我的',
        },
        components: {
            default: personal,
            header:Header,
        }
    },{
        path: '/techSiteIdInfo',
        name: 'techSiteIdInfo',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '网点信息',
        },
        components: {
            default: techSiteIdInfo,
            header:Header,
        }
    },{
        path: '/clockIn',
        name: 'clockIn',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '考勤打卡',
        },
        components: {
            default: clockIn,
            // header:Header,
        }
    },{
        path: '/saleStatistic',
        name: 'saleStatistic',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '销量数据',
        },
        components: {
            default: saleStatistic,
            header:Header,
        }
    },{

        path: '/saleOutletSite',
        name: 'saleOutletSite',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '网点销量查询',
        },
        components: {
            default: saleOutletSite,
            header:Header,
        }
    },{

        path: '/saleSiteInfo',
        name: 'saleSiteInfo',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '网点销量统计',
        },
        components: {
            default: saleSiteInfo,
            header:Header,
        }
    },
    {
        path: '/setting',
        name: 'setting',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '绩效设置',
        },
        components: {
            default: setting,
            header:Header,
            // footer:Footer,
        }
    },
    // {
    //     path: '/techMoveInfo',
    //     name: 'techMoveInfo',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: '移机任务详情',
    //     },
    //     components: {
    //         default: techMoveInfo,
    //         header:Header,
    //         // footer:Footer,
    //     }
    // },
    // {
    //     path: '/techRemoveInfo',
    //     name: 'techRemoveInfo',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: '撤机任务详情',
    //     },
    //     components: {
    //         default: techRemoveInfo,
    //         header:Header,
    //         // footer:Footer,
    //     }
    // },
    // {
    //     path: '/techInspection',
    //     name: 'techInspection',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: '彩票销售场所规范化巡检',
    //     },
    //     components: {
    //         default: techInspection,
    //         header:Header,
    //         // footer:Footer,
    //     }
    // },
    // {
    //     path: '/techUserUpdate',
    //     name: 'techUserUpdate',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: '代销者变更申请',
    //     },
    //     components: {
    //         default: techUserUpdate,
    //         header:Header,
    //         // footer:Footer,
    //     }
    // },
    // {
    //     path: '/map',
    //     name: 'map',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: 'map',
    //     },
    //     components: {
    //         default: map,
    //         // header:Header,
    //         // footer:Footer,
    //     }
    // },
];
//




